import script from "./GraphSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphSection.vue?vue&type=script&setup=true&lang=js"

import "./GraphSection.vue?vue&type=style&index=0&id=2489e9b9&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2489e9b9"]])

export default __exports__